import React from "react";
import classes from "./QuizCard.module.scss";
import { useNavigate } from "react-router-dom";
import ranking1 from "../../static/images/ranking/ranking-1.png";
import ranking2 from "../../static/images/ranking/ranking-2.png";
import ranking3 from "../../static/images/ranking/ranking-3.png";
import ranking4 from "../../static/images/ranking/ranking-4.png";
import ranking5 from "../../static/images/ranking/ranking-5.png";
import raingow from "../../static/images/circle-rainbow.png";
import gold from "../../static/images/circle-gold.png";
import green from "../../static/images/circle-green.png";

type Props = {
  index: number;
  summary?: string;
  tag: string;
  imageData: string;
  internalUrl: string;
  callback?: () => void;
  done?: boolean;
  correctNo?: number;
  isRanking?: boolean;
};

const QuizCard = (props: Props) => {
  const navigate = useNavigate();
  const getBadge = (correctNo: number) => {
    if (correctNo === 10) {
      return raingow;
    }

    if (correctNo >= 8) {
      return gold;
    }

    return green;
  };
  const getRank = (index: number) => {
    if (index === 0) {
      return ranking1;
    }

    if (index === 1) {
      return ranking2;
    }

    if (index === 2) {
      return ranking3;
    }

    if (index === 3) {
      return ranking4;
    }

    return ranking5;
  };

  const click = () => {
    if (props.internalUrl != null && props.internalUrl !== "") {
      navigate(props.internalUrl);
    }

    if (props.callback != null) {
      props.callback();
    }
  };

  return (
    <div className={classes.container} onClick={click}>
      {props.summary != null ? (
        <>
          <div className={classes.left}>
            <img
              className={classes.image}
              src={props.imageData}
              alt={props.imageData}
            />
            {props.isRanking && (
              <img
                className={classes.rank}
                src={getRank(props.index)}
                alt={getRank(props.index)}
              />
            )}
          </div>
          <div className={classes.right}>
            <div className={classes.metaRow}>
              <span className={classes.tag}>{props.tag}</span>
            </div>
            <div className={classes.summary}>{props.summary}</div>
            {props.done != null && props.done && (
              <>
                {props.correctNo != null ? (
                  <div className={classes.correctNo}>
                    {/* 丸画像と数字を重ねるバッジ */}
                    <div className={classes.badge}>
                      <img
                        className={classes.badgeImg}
                        src={getBadge(props.correctNo)}
                        alt=""
                      />
                      <span
                        className={`${classes.badgeNum} ${
                          props.correctNo === 10 ? classes.twoDigits : ""
                        }`}
                      >
                        {props.correctNo}
                      </span>
                    </div>
                    <span className={classes.text}>/10問</span>
                  </div>
                ) : (
                  <div className={classes.done}>実施済</div>
                )}
              </>
            )}
            {props.done != null && !props.done && (
              <div className={classes.yet}>未挑戦</div>
            )}
            {props.done == null && (
              <div></div>
            )}
          </div>
        </>
      ) : (
        <div className={classes.wide}>
          <img
            className={classes.image}
            src={props.imageData}
            alt={props.imageData}
          />
        </div>
      )}
    </div>
  );
};

export default QuizCard;
